export class Accordions {
  static selector = "[data-component=accordion]"

  constructor(el) {
    this.root = el

    this.setup()
  }

  onToggle = ev => {
    ev.preventDefault()
    const item = ev.target.closest(".accordion__item")
    item.toggleAttribute("data-open")
  }

  setup() {
    for (const a of this.root.querySelectorAll("[data-action=accordion-toggle]")) {
      a.addEventListener("click", this.onToggle)
    }
  }
}
